module.exports = __webpack_public_path__ + "static/media/telegram.82e4ab30.svg";